(ns nl.mediquest.ui.html)

(defn args->opts-children [args]
  (if (map? (first args)) [(first args) (rest args)] [{} args]))

(defn add-classes [opts classes]
  (-> opts
      (update :class #(concat classes %))
      (update :class flatten)))

(defn- base [element classes & args]
  (let [[opts children] (args->opts-children args)]
    [element
     (add-classes opts classes)
     (into [:<>] children)]))

(def card
  (partial base :div ["border" "rounded-lg" "border-gray-300" "p-4" "bg-white"]))

(def title
  (partial base :div ["text-primary" "font-semibold" "text-xl"]))

(defn- add-role-button [opts]
  (assoc opts :role :button))

(defn- button-base [element classes & args]
  (let [[opts children] (args->opts-children args)]
    [element
     (add-role-button (add-classes opts classes))
     (into [:<>] children)]))

(def style-button-primary
  ["bg-primary" "px-3" "py-2" "font-semibold" "rounded"
   "text-white" "inline-block" "hover:bg-primary-600"
   "select-none" "cursor-pointer"
   "active:bg-primary-700"])

(def button-primary
  (partial button-base :div style-button-primary))

(def style-button-primary-disabled
  ["px-3" "py-2" "font-semibold" "rounded"
   "text-white" "inline-block"
   "select-none" "cursor-not-allowed"
   "bg-gray-400" "hover:bg-gray-400" "active:bg-gray-400"])

(def button-primary-disabled
  (partial button-base :div style-button-primary-disabled))

(def style-button-secondary
  ["border-2" "px-3" "py-2" "font-semibold"
   "rounded" "inline-block" "cursor-pointer"
   "select-none"])

(def button-secondary
  (partial button-base :div style-button-secondary))

(def style-button-tertiary
  ["border-2" "px-3" "py-0" "font-semibold"
   "rounded" "inline-block" "cursor-pointer"
   "select-none"])

(def button-tertiary
  (partial button-base :div style-button-tertiary))
